angular.module('gym.pos').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.pos.taxRates', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.pos.taxRates.list', {
    url: '/tax_rates',
    template: require('templates/gyms/pos/tax_rates/index.html.slim')
  });
}]);
